import {
  ServiceDefinition,
  ServiceConfig,
  UpdateServiceConfigDTO,
} from '@/interface/types/user'
import { api } from '../axios-instance'

export const serviceManagementService = {
  getDefinitions: async () => {
    const response = await api.get<{ services: ServiceDefinition[] }>(
      '/service-management/definitions',
    )
    return response.data
  },

  getDefinitionsByRole: async (role: string) => {
    const response = await api.get<{ services: ServiceDefinition[] }>(
      `/service-management/definitions/role/${role}`,
    )
    return response.data
  },

  getCategories: async () => {
    const response = await api.get<string[]>('/service-management/categories')
    return response.data
  },

  getUserServiceConfig: async (userId: string) => {
    const response = await api.get<{
      userId: string
      services: Record<string, Omit<ServiceConfig, 'serviceId'>>
    }>(
      `/service-management/user/${userId}/config`,
    )
    return response.data
  },

  getMyConfig: async () => {
    const response = await api.get<{
      userId: string
      services: Record<string, Omit<ServiceConfig, 'serviceId'>>
    }>(
      '/service-management/my-config',
    )
    return response.data
  },

  updateUserServiceConfig: async (
    userId: string,
    serviceId: string,
    data: UpdateServiceConfigDTO,
  ) => {
    const response = await api.patch(
      `/service-management/user/${userId}/service/${serviceId}`,
      data,
    )
    return response.data
  },

  bulkUpdateUserServices: async (userId: string, updates: any[]) => {
    const response = await api.post(
      `/service-management/user/${userId}/bulk-update`,
      { updates },
    )
    return response.data
  },

  initializeUserServices: async (userId: string) => {
    const response = await api.post(
      `/service-management/user/${userId}/initialize`,
    )
    return response.data
  },
}
